// plugins/loginModal.js
import Vue from 'vue'
import LoginModal from '@/components/login'
import router from '@/router'
import i18n from '@/lang'

export default {
  show(options = {}) {
    const Constructor = Vue.extend(LoginModal)
    // 注入 i18n 和 router，上下文继承父实例（如果提供）
    const instance = new Constructor({
      i18n,
      router,
      parent: options.parent || router.app || undefined
    }).$mount()
    document.body.appendChild(instance.$el)
    instance.$on('closeLogin', () => {
      // 如果需要执行传递的回调
      if (typeof instance.onClose==='function') {
        instance.onClose()
      }
    })
    Object.assign(instance, {
      onClose: options.onClose || (() => {}), // 默认空函数
      onSuccess: options.onSuccess || (() => {}), // 默认空函数

      // 可透传其他参数...
    })
    // 封装带回调的 show 方法
    // 事件监听
    instance.$on('success', () => {
      instance.onClose() // 登录成功后自动关闭
      instance.onSuccess();
    })
  },
}